import React from 'react';
import {z} from 'zod';

import {Apartment} from '@mui/icons-material';

import {Logo,LogoPropsSchema} from './Logo';
import LogoSidebarPanel from './LogoSidebarPanel';

export type LogoProps = z.infer<typeof LogoPropsSchema>;

export default {
    label: 'Logo',
    icon: <Apartment />,
    type: 'Logo',
    defaultData: {
        props: {
            logo: 'main',
            logos: {},
            width: null,
            height: null,
        },
        style: {
            backgroundColor: null,
            textAlign: 'left',
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
        },
    },
    SidebarPanel: LogoSidebarPanel,
    Component: Logo,
    schema: LogoPropsSchema,
};